import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { resolveHost } from "@/web/publicApi";
import PublicWebSite from "@/pages/web/PublicWebSite";
import PublicWebOrder from "@/pages/web/PublicWebOrder";

// Phase 82 — si l'app est servie sur `slug.avenuerh.pro` ou un domaine perso vérifié, on rend directement le mini-site.
const APP_HOST = (() => { try { return new URL(process.env.REACT_APP_BACKEND_URL).hostname; } catch { return ""; } })();
const isAppHost = (h) => !h || h === APP_HOST || h === "localhost" || h === "127.0.0.1" || h.endsWith(".emergentagent.com") || h.endsWith(".emergent.host");

export function HostSiteGate({ children }) {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const app = isAppHost(host);
  const [state, setState] = useState({ done: app, slug: null });
  useEffect(() => {
    if (app) return;
    resolveHost(host).then((r) => setState({ done: true, slug: r.data?.slug || null })).catch(() => setState({ done: true, slug: null }));
  }, [host, app]);
  if (!state.done) return <div className="min-h-screen flex items-center justify-center text-sm text-[#868E96]" data-testid="host-resolving">Chargement…</div>;
  if (!state.slug) return children;
  const slug = state.slug;
  return (
    <Routes>
      <Route path="/" element={<PublicWebSite slug={slug} base="" />} />
      <Route path="/commande/:ref" element={<PublicWebOrder slug={slug} base="" />} />
      <Route path="/s/:slug" element={<PublicWebSite />} />
      <Route path="/s/:slug/commande/:ref" element={<PublicWebOrder />} />
      <Route path="/s/:slug/:page" element={<PublicWebSite />} />
      <Route path="/:page" element={<PublicWebSite slug={slug} base="" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
